var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.381 16.8402C11.0423 16.6107 10.598 16.6107 10.2593 16.8402L5.58808 20.0046C4.81182 20.5304 3.80378 19.7949 4.06765 18.8952L5.64512 13.5166C5.7612 13.1208 5.62236 12.6943 5.2955 12.4427L0.845708 9.01752C0.101186 8.44442 0.486372 7.2539 1.42549 7.22554L7.06112 7.05537C7.47132 7.04298 7.8323 6.78123 7.97158 6.3952L9.8795 1.10714C10.1973 0.22632 11.443 0.226322 11.7608 1.10715L13.6687 6.3952C13.808 6.78123 14.169 7.04298 14.5792 7.05537L20.2148 7.22554C21.1539 7.2539 21.5391 8.44442 20.7946 9.01751L16.3448 12.4427C16.0179 12.6943 15.8791 13.1208 15.9952 13.5166L17.5726 18.8952C17.8365 19.7949 16.8285 20.5304 16.0522 20.0046L11.381 16.8402Z",
    fill: "#EEEDEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarEmpty);
export default __webpack_public_path__ + "static/media/icon_star_empty.edb94bd5cd54a418c3e63bf6442fcade.svg";
export { ForwardRef as ReactComponent };